import React, { Component } from "react";
import {
  Paper,
  Subheader,
  alert,
  Divider,
  FlatButton,
  CircularProgress,
  Table,
  TableHeader,
  TableRow,
  TableBody,
  TableRowColumn,
  IconButton,
  Dialog,
} from "material-ui";
import Formsy from "formsy-react";
import Loading from "../Loading";
import { Link } from "react-router";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import ReactTooltip from "react-tooltip";
import Dropzone from "react-dropzone";
import companyListIcon from "../../images/company_list.png";
import searchIcon from "../../images/search.png";
import editDefaultIcon from "../../images/edit_default.png";
import deleteDefaultIcon from "../../images/delete_default.png";
import importDefaultIcon from "../../images/import_default.png";
import addIcon from "../../images/add_icon.png";
import AddPayrollCompany from "./AddPayrollCompany";
import ShowCompanyDetail from "./ShowCompanyDetail";
import PublishForm from "../PublishForm";

class PayrollInput extends Component {
  constructor(props) {
    super(props);

    this.state = {
      submitEnabled: true,
      message: "Click to upload file, or drag and drop file",
      file: "",
      response: "",
      isLoading: false,
      companies: [],
      openCmp: false,
      company: {
        companyId: "",
        company: "",
        contactNumber: "",
        address: "",
        _id: "",
      },
      searchValue: "",
      searchTextValue: "",
      openDeleteConfirmPopup: false,
      currentSelectedRow: {},
      isOpenCompanyDetail: false,
      selectedCompanyData: {},
      styles: {
        centerStyle: {
          marginBottom: "1em",
          marginLeft: "auto",
          marginRight: "auto",
          width: "75%",
        },
        zone: {
          width: "100%",
          height: "100px",
          border: "3px dashed #2979ff",
        },
        activeZone: {
          width: "100%",
          height: "100px",
          border: "3px dashed #2979ff",
          backgroundColor: "Aquamarine",
        },
        zoneText: {
          textAlign: "center",
          fontSize: "2em",
        },
      },
    };

    this.onDrop = this.onDrop.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.renderContent = this.renderContent.bind(this);
    this.deleteButtonFormatter = this.deleteButtonFormatter.bind(this);
    this.editButtonFormatter = this.editButtonFormatter.bind(this);
    this.importButtonFormatter = this.importButtonFormatter.bind(this);
    this.resetForm = this.resetForm.bind(this);
  }

  componentDidMount() {
    this.getAllCompanies("");
  }

  editButtonFormatter(cell, row) {
    return (
      <IconButton
        onClick={() => {
          this.editCompany(row);
        }}
        style={{
          width: "25px",
          height: "25px",
          padding: "0px",
          paddingLeft: "15px",
        }}
      >
        <p data-tip="Edit" data-for="editTooltip">
          <img src={editDefaultIcon} />
        </p>
        <ReactTooltip id="editTooltip" />
      </IconButton>
    );
  }

  deleteButtonFormatter(cell, row) {
    console.log("row----11---------", row);
    return (
      <IconButton
        onClick={() => {
          this.deleteCompany(row);
        }}
        style={{
          width: "25px",
          height: "25px",
          padding: "0px",
          paddingLeft: "15px",
        }}
      >
        <p data-tip="Delete" data-for="deleteTooltip">
          <img src={deleteDefaultIcon} />
        </p>
        <ReactTooltip id="deleteTooltip" />
      </IconButton>
    );
  }

  importButtonFormatter(cell, row) {
    return (
      <IconButton
        onClick={() => {
          this.showCompanyDetailMethod(row);
        }}
        style={{
          width: "25px",
          height: "25px",
          padding: "0px",
          paddingLeft: "15px",
        }}
      >
        <p data-tip="Add Employee" data-for="addEmployeeTooltip">
          <img src={addIcon} />
        </p>
        <ReactTooltip id="addEmployeeTooltip" />
      </IconButton>
    );
  }

  getAllCompanies = (searchValue) => {
    let url = `/api/payroll/getAllCompanies`;
    if (searchValue) {
      url = `/api/payroll/getAllCompanies?searchText=` + searchValue;
    }
    let options = {
      headers: {
        token: this.props.token.jwt,
      },
    };
    fetch(url, options)
      .then((res) => {
        if (res.status >= 200 && res.status < 300) return res.json();
      })
      .then((json) => {
        this.setState({ isLoading: false, companies: json.companies });
      });
  };

  submitForm(e) {
    //e.preventDefault();
    // alert(JSON.stringify(data, null, 4));
    if (this.state.file) {
      this.setState({ isLoading: true });
      let formData = new FormData();
      let url = "/api/payroll/upload";
      let options = {
        method: "POST",
        headers: {
          token: this.props.token.jwt,
        },
        body: formData,
      };
      formData.append("file", this.state.file);
      fetch(url, options)
        .then((response) => response.json())
        .then((json) => {
          this.setState({ response: json, isLoading: false });
        });
    }
  }

  notifyFormError(data) {
    alert("Form error:", JSON.stringify(data, null, 4));
  }

  resetForm() {
    this.setState({
      file: "",
      response: "",
      isLoading: false,
      submitEnabled: true,
      message: "Click to upload file, or drag and drop file",
    });
  }

  onDrop(e) {
    if (e[0].type === "application/pdf") {
      this.setState({ file: e[0], submitEnabled: true });
    } else {
      this.setState({
        message: `Incorrect File Type, expecting PDF`,
        submitEnabled: false,
      });
    }
  }

  editCompany = (row) => {
    console.log("row--------", row);
    this.setState({ company: row, openCmp: true });
  };

  deleteCompanyData = () => {
    let { currentSelectedRow } = this.state;
    var me = this;
    let url = `/api/payroll/deleteCompany/${currentSelectedRow._id}`;
    let options = {
      method: "delete",
      headers: {
        token: this.props.token.jwt,
      },
    };
    fetch(url, options)
      .then((res) => {
        if (res.status >= 200 && res.status < 300) {
          me.closeDeleteConfirmPopup();
          me.getAllCompanies("");
        }
      })
      .then((json) => {
        me.closeDeleteConfirmPopup();
        this.setState({ isLoading: false });
      });
  };

  deleteCompany = (row) => {
    console.log("row---22----------------", row);
    this.setState({
      openDeleteConfirmPopup: true,
      currentSelectedRow: row,
      selectedCompanyData: row,
    });
  };

  showCompanyDetailMethod = (row) => {
    this.setState({ isOpenCompanyDetail: true, selectedCompanyData: row });
  };

  renderTable() {
    if (this.state.isLoading) {
      return (
        <div className="container">
          <center>
            <Loading color={this.props.appbar.color} />
          </center>
        </div>
      );
    } else {
      let filter = { type: "TextFilter", delay: 500 };
      let { companies } = this.state;
      return (
        <div className="mainTableCls">
          <BootstrapTable
            data={companies}
            bordered={false}
            pagination
            style={{ background: "#fff" }}
            rowClasses="custom-row-class"
          >
            <TableHeaderColumn
              dataField="companyId"
              width="100"
              isKey={true}
              tdStyle={{ background: "#fff" }}
            >
              Company Id
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="company"
              width="100"
              tdStyle={{ background: "#fff" }}
            >
              Company Name
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="address"
              width="100"
              tdStyle={{ background: "#fff" }}
            >
              Address
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="contactNumber"
              width="100"
              tdStyle={{ background: "#fff" }}
            >
              Contact
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="button"
              dataFormat={this.editButtonFormatter}
              width="20"
              tdStyle={{ background: "#fff" }}
            ></TableHeaderColumn>
            <TableHeaderColumn
              dataField="button"
              dataFormat={this.deleteButtonFormatter}
              width="20"
              tdStyle={{ background: "#fff" }}
            ></TableHeaderColumn>
            <TableHeaderColumn
              dataField="button"
              dataFormat={this.importButtonFormatter}
              width="20"
              tdStyle={{ background: "#fff" }}
            ></TableHeaderColumn>
          </BootstrapTable>
        </div>
      );
    }
  }

  renderContent() {
    let { response, isLoading } = this.state;
    let { zone, activeZone, centerStyle } = this.state.styles;
    let filter = { type: "TextFilter", delay: 500 };

    if (isLoading) {
      let size = window.screen.width / 7;
      return (
        <center>
          <CircularProgress
            color={this.props.appbar.color || "#424242"}
            size={size}
            thickness={20}
          />
        </center>
      );
    } else if (!response) {
      return (
        <div>
          <Dropzone
            onDrop={this.onDrop}
            disablePreview={true}
            style={zone}
            activeStyle={activeZone}
          >
            <center>
              <h4>
                {this.state.file ? this.state.file.name : this.state.message}
              </h4>
            </center>
          </Dropzone>
        </div>
      );
    } else {
      return (
        <div>
          <h4>In case of a failed email:</h4>
          <p>
            1.Download the individual paystub from AccountantsWorld for each
            failed email
          </p>
          <p>2. Reset form</p>
          <p>3. Upload single file</p>
          <p>4. Repeat step 2 and 3 for each paystub</p>
          <BootstrapTable data={response}>
            <TableHeaderColumn
              dataField="empId"
              filter={filter}
              dataSort
              isKey
              width="50"
            >
              EmpID
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="name"
              dataSort
              filter={filter}
              width="300"
            >
              Name
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="checkDate"
              dataSort
              filter={filter}
              width="100"
            >
              Check Date
            </TableHeaderColumn>
            <TableHeaderColumn dataField="sent" dataSort filter={filter}>
              Email Sent
            </TableHeaderColumn>
          </BootstrapTable>
        </div>
      );
    }
  }

  sentFormatter(status) {
    let color;
    if (status !== "Success") {
      color = "red";
    }

    return <div style={{ color: color }}>{status}</div>;
  }

  showAddCompany = () => {
    this.setState({
      openCmp: true,
      company: {
        companyId: "",
        company: "",
        contactNumber: "",
        address: "",
        _id: "",
      },
    });
  };

  closeAddCompanyPopup = () => {
    console.log("inside close");
    this.setState({
      openCmp: false,
      company: {
        companyId: "",
        company: "",
        contactNumber: "",
        address: "",
        _id: "",
      },
    });
    this.getAllCompanies("");
  };

  closeDeleteConfirmPopup = () => {
    this.setState({ openDeleteConfirmPopup: false, currentSelectedRow: {} });
  };

  // This method is used for searching
  submitSearchForm(searchText) {
    var me = this;
    if (searchText != "" && searchText != null) {
      me.getAllCompanies(searchText.trim());
      this.setState({ isLoading: false, searchTextValue: searchText.trim() });
    } else {
      this.setState({ searchTextValue: "" });
      me.getAllCompanies("");
    }
  }
  showPayrollPage = () => {
    this.setState({ isOpenCompanyDetail: false });
  };

  render() {
    let { centerStyle } = this.state.styles;
    let { openDeleteConfirmPopup, isOpenCompanyDetail } = this.state;
    return (
      <div>
        <div style={{ display: isOpenCompanyDetail ? "none" : "block" }}>
          <Paper className="container" zDepth={2} style={{ marginTop: "1em" }}>
            <div style={{ margin: "1em" }}>
              <span className="companyListTitle">Pay Stub Porter</span>
            </div>
            <Divider />
            <br />
            <div style={centerStyle}>{this.renderContent()}</div>
            <Divider />
            <br />
            <Formsy.Form
              ref="form"
              onValidSubmit={this.submitForm}
              onInvalidSubmit={this.notifyFormError}
              submitForm={this.submitForm}
              resetForm={this.resetForm}
            >
              <div
                style={{ centerStyle, float: "right", marginBottom: "0.5em" }}
              >
                <FlatButton
                  className="flatButtonCls"
                  disabled={
                    this.state.isLoading ||
                    !!this.state.response ||
                    !this.state.submitEnabled
                  }
                  type="submit"
                  label="Submit"
                />
                <FlatButton
                  className="flatButtonCls"
                  disabled={this.state.isLoading}
                  label="reset"
                  onClick={this.resetForm.bind(this)}
                  style={{ marginLeft: "0.5em" }}
                />
              </div>
            </Formsy.Form>
          </Paper>
          <br />
          <div>
            <div>
              <span className="companyListTitle">Company List</span>
            </div>
            <div>
              <div
                className="searchTextCls"
                style={{ display: "inline-block" }}
              >
                <input
                  type="text"
                  value={this.state.searchTextValue}
                  className="searchInputCls"
                  placeholder="Search Company Name"
                  onChange={(e) => this.submitSearchForm(e.target.value)}
                />
                <span
                  className="searchImgCls"
                  onClick={() => {
                    this.clearSearchText();
                  }}
                >
                  <img src={searchIcon} style={{ width: "16px" }} />
                </span>
              </div>
              <div style={{ display: "inline-block", float: "right" }}>
                <FlatButton
                  onClick={this.showAddCompany}
                  className="flatButtonCls"
                  style={{ width: "120px" }}
                >
                  Add Company
                </FlatButton>
              </div>
            </div>
            {this.renderTable()}
          </div>
        </div>
        <AddPayrollCompany
          open={this.state.openCmp}
          token={this.props.token}
          company={this.state.company}
          closeAddCompanyPopup={this.closeAddCompanyPopup}
        />
        <ShowCompanyDetail
          open={isOpenCompanyDetail}
          token={this.props.token}
          companyData={this.state.selectedCompanyData}
          showPayrollPage={this.showPayrollPage}
          getAllCompanyData={this.getAllCompanies}
        />
        <Dialog
          title="Delete Company"
          open={openDeleteConfirmPopup}
          onRequestClose={this.closeDeleteConfirmPopup}
          style={{
            width: openDeleteConfirmPopup ? "50%" : "0",
            textAlign: "center",
            left: "30%",
          }}
        >
          Are you sure you want to delete this company?
          <br />
          <br />
          <FlatButton
            type="button"
            className="flatButtonCls"
            onTouchTap={this.deleteCompanyData}
          >
            Yes
          </FlatButton>
          <FlatButton
            type="button"
            style={{ marginLeft: "2rem" }}
            className="flatButtonCls"
            onTouchTap={this.closeDeleteConfirmPopup}
          >
            No
          </FlatButton>
        </Dialog>
      </div>
    );
  }
}

export default PayrollInput;



// WEBPACK FOOTER //
// ./app/components/Payroll/PayrollInput.js